import _ from 'underscore';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { DataSources } from '../../content/resources/Datasources';
import {
  ISetDatasourceRemoteAgentReservationResult,
} from '../ServerApi/requests/SetDatasourceRemoteAgentReservationRequest';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ChangeDatasourceRemoteAgentAction } from './ChangeDatasourceRemoteAgentAction';
import { ToasterService, ToastType } from './ToasterService';
import { Messages } from '../../codegen/Localize';

export namespace ChangeDatasourceRemoteAgentReservationAction {

  export function execute(datasource: IDataSourceBase,
                 reservationId: string,
                 suppressSuccessToast: boolean): Promise<IResult> {

    return DataSources.setRemoteAgentReservation(datasource.id, reservationId).then((result: ISetDatasourceRemoteAgentReservationResult) => {
      if (!suppressSuccessToast) {
        if (_.isEmpty(result.errors)) {
          ToasterService.instance.pop({
            type: ToastType.Info,
            text: successMessageFor(result.updatedRemoteAgentName)
          });
        } else {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: errorMessageFor(result.errors[0], datasource)
          });
        }
      }
      return result;
    });

  }

  function errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      default:
        return Messages.errorUnknown();
    }
  }

  function successMessageFor(updatedRemoteAgentName: string): string {
    // If there is an agent name, the backend found a agent for this reservation right away.
    return _.isEmpty(updatedRemoteAgentName)?
      // Use a generic message that does not include the agent name.
      Messages.editRemoteRefreshPropertiesAgentReservationSuccess():
      // Use that agent name in the success message.
      ChangeDatasourceRemoteAgentAction.successMessageFor(updatedRemoteAgentName);
  }

}

export type ChangeDatasourceRemoteAgentReservationAction = typeof ChangeDatasourceRemoteAgentReservationAction;
